module.exports = __webpack_public_path__ + "static/media/roccul-ltd.7f415bff.jpg";